import { render } from "./DCard.vue?vue&type=template&id=78b0b34e&scoped=true"
import script from "./DCard.vue?vue&type=script&lang=js"
export * from "./DCard.vue?vue&type=script&lang=js"

import "./DCard.vue?vue&type=style&index=0&id=78b0b34e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b0b34e"]])

export default __exports__